import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileTypeIcon'
})
export class FileTypeIconPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let extension = this.getFileExtension(value);
    if (args == 'icon-class') {
      if(extension == 'zip' || extension == 'epub') return 'bi-file-earmark-zip';
      else return 'bi-filetype-'+ extension;
    }
    else if(args == 'type') return extension;
    else return 'bi-filetype-'+ extension;
  }

  getFileExtension(filename:string) {
    let ext = /^.+\.([^.]+)$/.exec(filename);
    return ext == null ? "" : ext[1];
  }
}


// WEBPACK FOOTER //
// ./public/app/_pipes/file-type-icon.pipe.ts